import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import AppShell from "./components/AppShell";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Today from "./pages/Today";
import Plan from "./pages/Plan";
import WorkoutDetail from "./pages/WorkoutDetail";
import Coach from "./pages/Coach";
import Progress from "./pages/Progress";
import Profile from "./pages/Profile";
import Import from "./pages/Import";

function Loader() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="brand-gradient w-14 h-14 rounded-2xl animate-pulse" />
    </div>
  );
}

function Protected({ children }) {
  const { user, onboarded, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!onboarded) return <Navigate to="/onboarding" replace />;
  return <AppShell>{children}</AppShell>;
}

function AuthRoute() {
  const { user, onboarded, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to={onboarded ? "/today" : "/onboarding"} replace />;
  return <Auth />;
}

function OnboardingRoute() {
  const { user, onboarded, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (onboarded) return <Navigate to="/today" replace />;
  return <Onboarding />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/auth" element={<AuthRoute />} />
            <Route path="/onboarding" element={<OnboardingRoute />} />
            <Route path="/today" element={<Protected><Today /></Protected>} />
            <Route path="/plan" element={<Protected><Plan /></Protected>} />
            <Route path="/workout/:id" element={<Protected><WorkoutDetail /></Protected>} />
            <Route path="/coach" element={<Protected><Coach /></Protected>} />
            <Route path="/progress" element={<Protected><Progress /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/import" element={<Protected><Import /></Protected>} />
            <Route path="*" element={<Navigate to="/today" replace />} />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
